module.exports = __webpack_public_path__ + "img/sydl.b486e629.svg";